import FilterStore from "../abstract.filter.store";
import {ServicerModuleServiceInterface, ServicerModuleStoreInterface} from "../../types";
import {
    ServicerAddRequest,
    ServicerEditRequest,
    ServicerPrepareEditFormRequest, ServicerViewAgenciesRequest,
    ServicerViewRequest
} from "../../types/modules/servicer/request";
import {ActionEnum, ResponseTypeEnum, TranslationDomainEnum} from "../../types/enums";
import {action, makeObservable, observable, runInAction} from "mobx";
import {UserListItem} from "../../types/modules/user/modules";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";

export default class ServicerStore extends FilterStore implements ServicerModuleStoreInterface {
    public _items: UserListItem[] = [];

    readonly _module: string = 'servicer'

    readonly _headers: string[] = [
       'name', 'tpNumber', 'externalId', 'chamberOfCommerceNumber', 'addressString', 'active'
    ]

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT, ActionEnum.VIEW_HISTORY
    ]


    constructor(
        private readonly appStore: AppStore,
        private readonly service: ServicerModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }

    public list = async () => {
        runInAction(() => {
            this.loading = true;
        });

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = async (request: ServicerEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('servicer.message.servicer_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public view = async (request: ServicerViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public add = async (request: ServicerAddRequest) => {
        this.appStore.setLoading(true);
        return this.service.add(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('servicer.message.servicer_add_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public prepareEditForm = async (request: ServicerPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }

    public prepareAddForm = async () => {
        return this.service.prepareAddForm()
            .then(({data}) => {
                return data;
            });
    }

    public viewHistory = async (request: ServicerViewRequest) => {
        return this.service.viewHistory(request)
            .then(({data}) => {
                return data;
            });
    }

    public viewAgencies = async (request: ServicerViewAgenciesRequest) => {
        return this.service.viewAgencies(request)
            .then(({data}) => {
                return data;
            });
    }
}